import React from 'react';

const HomeAboutInterview = () => {
    return (
        <div className=''>
            <h2 className='text-color text-center'>Interview Upcoming Soon...</h2>
        </div>
    );
};

export default HomeAboutInterview;